import { AssignmentSubscriptionPlace } from '../providers/api/dtos';

export const assignmentSubscriptionPlaceLabels: {
  [key in AssignmentSubscriptionPlace]: string
} = {
  IN_AGENT_LOCALES: 'Presso i locali dell\'Agente',
  OUT_OF_AGENT_LOCALES: 'Fuori dai locali dell\'Agente',
  REMOTE: 'A distanza',
};
